import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import { Trophy, Crown, Medal } from "@phosphor-icons/react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

const ranks = ["text-[#1E3A8A]", "text-slate-600", "text-orange-400"];
const rankIcons = [Crown, Medal, Medal];

export default function Leaderboard() {
    const [rows, setRows] = useState([]);
    useEffect(() => {
        (async () => {
            const { data } = await api.get("/leaderboard");
            setRows(data);
        })();
    }, []);

    return (
        <Layout>
            <div className="mb-8">
                <div className="text-xs uppercase tracking-widest text-slate-500">Leaderboard</div>
                <h1 className="font-heading font-bold text-3xl sm:text-4xl mt-1">Top aspirants this season</h1>
                <p className="text-slate-500 mt-2 text-sm">Ranked by total correct answers across all MCQ attempts.</p>
            </div>

            {rows.length === 0 ? (
                <div className="bento-card text-slate-500 flex items-center gap-3">
                    <Trophy size={22} className="text-[#1E3A8A]" weight="duotone" /> Be the first to make the leaderboard — take a test!
                </div>
            ) : (
                <div className="bento-card p-0 overflow-hidden">
                    <div className="grid grid-cols-12 px-6 py-3 border-b border-[#BFD3FF] text-xs uppercase tracking-widest text-slate-500 font-mono">
                        <div className="col-span-1">#</div>
                        <div className="col-span-6">Aspirant</div>
                        <div className="col-span-2 text-right">Tests</div>
                        <div className="col-span-1 text-right">Acc</div>
                        <div className="col-span-2 text-right">Score</div>
                    </div>
                    {rows.map((r, i) => {
                        const RankIcon = rankIcons[i] || null;
                        return (
                            <div key={r.user_id} className={`grid grid-cols-12 items-center px-6 py-4 border-b border-[#BFD3FF] last:border-0 hover:bg-slate-100/60 transition-colors ${i < 3 ? "bg-gold/[0.02]" : ""}`}>
                                <div className={`col-span-1 font-mono font-bold text-lg flex items-center gap-1 ${ranks[i] || "text-slate-600"}`}>
                                    {i < 3 && RankIcon ? <RankIcon size={18} weight="fill" /> : null}
                                    {i + 1}
                                </div>
                                <div className="col-span-6 flex items-center gap-3">
                                    <Avatar className="w-9 h-9">
                                        <AvatarImage src={r.picture} alt={r.name} />
                                        <AvatarFallback>{(r.name || "U").charAt(0)}</AvatarFallback>
                                    </Avatar>
                                    <div className="font-medium">{r.name}</div>
                                </div>
                                <div className="col-span-2 text-right font-mono text-slate-600">{r.tests_taken}</div>
                                <div className="col-span-1 text-right font-mono text-slate-600">{r.avg_accuracy}%</div>
                                <div className="col-span-2 text-right font-mono text-[#1E3A8A] font-bold">{r.total_score}</div>
                            </div>
                        );
                    })}
                </div>
            )}
        </Layout>
    );
}
